module.exports = __webpack_public_path__ + "483aeca32a8bd8f443926f7652e7ab09.pdf";